import { resolveBrowserLocale } from 'react-admin';
import polyglotI18nProvider from 'ra-i18n-polyglot';
import en from 'ra-language-english';

import fr from './fr';
import de from './de';
import nl from './nl';
import pl from './pl';
import it from './it';

const translations = { en, fr, de, nl, pl, it };

export const i18nProvider = polyglotI18nProvider(
    locale => translations[locale],
    resolveBrowserLocale('en'),
    [
        { locale: 'en', name: 'EN' },
        { locale: 'fr', name: 'FR' },
        { locale: 'de', name: 'DE' },
        { locale: 'nl', name: 'NL' },
        { locale: 'pl', name: 'PL' },
        { locale: 'it', name: 'IT' },
    ],
    { allowMissing: true }
);

export default i18nProvider;